// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import PageSections from 'church-theme-library/components/PageSections/_PageSections'

// Redux:
import { getPageData, setCurrentlyViewedPage, registerPageView } from 'church-theme-library/redux/actions/page'

class Page extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			topWaypointEntered: false,
			bottomWaypointEntered: false,
			hasLoadedNext: false
		}
	}

	handleTopWaypointEnter = () => {
		const { dispatch, currentlyViewedPage, match } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		const { bottomWaypointEntered } = this.state

		if ( page.slug != currentlyViewedPage.slug ) {
			// Set this post as the current:
			dispatch( setCurrentlyViewedPage( page.slug, match ) )
		}

		if ( ! bottomWaypointEntered || page.slug != currentlyViewedPage.slug ) {
			// dispatch( registerPageView( page.id ) )

			this.setState({
				bottomWaypointEntered: true
			})
		}
	}

	handleBottomWaypointEnter = () => {
		const { dispatch } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return
		}

		this.setState( {
			hasLoadedNext: true
		} )

		// Fetch the next post:
		if ( page.next_post_slug ) {
			dispatch(
				getPageData( {
					type: 'post',
					slug: page.next_post_slug + '',
					requestOnly: true,
					append: true
				} )
			)
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { hasLoadedNext } = this.state

		return (
			<div>
				<Waypoint
					onEnter={ this.handleTopWaypointEnter }
				/>

				<PageSections { ...this.props } />

				{ ! hasLoadedNext &&
					<div className="-waypoint">
						<Waypoint
							onEnter={ this.handleBottomWaypointEnter }
						/>
					</div>
				}
			</div>
		)
	}

	render() {
		return (
			<div>
				{ this.props.isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected,
		currentlyViewedPage: state.page.currentlyViewedPage
	}
}

export default connect( mapStateToProps )( Page )
